export default "__VITE_ASSET__f12a3038__"